module.exports = __webpack_public_path__ + "static/media/TemploMon.f21cbfb6.png";